import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { reelSymbolNames } from './reelConstants';
import { powerOfGodsStore } from '../../powerOfGodsStores/powerOfGodsStore';
import winPopupBg from '../../../../assets/images/power-gods/win-popup-bg.png';
import { soundService } from '../../../../services/baseSoundService/soundService';

export const PowerOfGodsCanvasConfigMobile = {
  antialias: true,
  backgroundAlpha: 0,
  width: 359,
  height: powerOfGodsStore.isBettingPartEnabled ? 547 : 307,
};

export const PowerOfGodsCanvasConfigWeb = {
  antialias: true,
  backgroundAlpha: 0,
  width: 1408,
  height: 774,
};

export const AnimationConfigs = {
  loop: 'linear',
  stopNormal: 'customStopNormal',
  stopTurbo: 'customStopTurbo',
  lineLoadingDuration: 0.5,
  lineCashOutDuration: 1.5,
  resetBigRingForBonusCompleteDuration: 1.5,
  bonusReelStretchingBackOutValues: [2, 9],
  bonusLoopStepDuration: 0.8,
  bonusLoopDuration: 4,
  bonusEase: 'power2.out',
};

export const actions = {
  bet: 1,
  cashOut: 3,
  partCashOut: 2,
};

export const awaitAfterDoSpinInSeconds = 0.5;

export const gameGlobalStates = {
  none: 'none',
  show: 'show',
  waiting: 'waiting',
  bonus: {
    bonusInit: 'bonusInit',
    bonusInitComplete: 'bonusInitComplete',
    bonusWaiting: 'bonusWaiting',
    bonusShow: 'bonusShow',
    bonusEnd: 'bonusEnd',
  },
};

export const winTypes = {
  0: 'Bet',
  1: 'AutoCashOut',
  2: 'PartCashout',
  3: 'CashOut',
  4: 'Bonus',
};
export const winTypesEnum = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
};
export const spineKeysConfig = {
  0: reelSymbolNames.medusa,
  1: reelSymbolNames.hermes,
  2: reelSymbolNames.ares,
  3: reelSymbolNames.aphrodite,
  4: reelSymbolNames.zeus,
  5: reelSymbolNames.x100,
  6: reelSymbolNames.x200,
  7: reelSymbolNames.x300,
  8: reelSymbolNames.x400,
  9: reelSymbolNames.x500,
  10: reelSymbolNames.x550,
  popup: 'popup',
  matrix: 'matrix',
  x75PopUp: 'x75PopUp',
  x225PopUp: 'x225PopUp',
  winCoin: 'winCoin',
  loading: 'loading',
  winPopup: 'winPopup',
  lightning: 'lightning',
  barFX: 'barFX',
  transition: 'transition',
};

export const cashOutPopUpNames = {
  middle: 'x225',
  small: 'x75',
};
export const gameImages = {
  winPopupBg: isMobile() ? winPopupBg : winPopupBg,
};
export const gameResources = () => {
  const webSceneSpineResources = {
    0: {
      name: reelSymbolNames.medusa,
      path: 'animations/power_of_gods_new/reelSymbols/web/medusa/medusa.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/medusa/medusa.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    1: {
      name: reelSymbolNames.hermes,
      path: 'animations/power_of_gods_new/reelSymbols/web/hermes/hermes.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/hermes/hermes.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    2: {
      name: reelSymbolNames.ares,
      path: 'animations/power_of_gods_new/reelSymbols/web/ares/ares.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/ares/ares.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    3: {
      name: reelSymbolNames.aphrodite,
      path: 'animations/power_of_gods_new/reelSymbols/web/aphrodite/Aphrodite.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/aphrodite/Aphrodite.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    4: {
      name: reelSymbolNames.zeus,
      path: 'animations/power_of_gods_new/reelSymbols/web/zeus/zeus.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/zeus/zeus.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    6: {
      name: reelSymbolNames.x100,
      path: 'animations/power_of_gods_new/reelSymbols/web/x100/100.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/x100/100.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    7: {
      name: reelSymbolNames.x200,
      path: 'animations/power_of_gods_new/reelSymbols/web/x200/200.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/x200/200.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    8: {
      name: reelSymbolNames.x300,
      path: 'animations/power_of_gods_new/reelSymbols/web/x300/300.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/x300/300.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    9: {
      name: reelSymbolNames.x400,
      path: 'animations/power_of_gods_new/reelSymbols/web/x400/400.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/x400/400.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    10: {
      name: reelSymbolNames.x500,
      path: 'animations/power_of_gods_new/reelSymbols/web/x500/500.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/x500/500.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    11: {
      name: reelSymbolNames.x550,
      path: 'animations/power_of_gods_new/reelSymbols/web/x550/550.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/web/x550/550.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    matrix: {
      name: spineKeysConfig.matrix,
      path: 'animations/power_of_gods_new/matrix/web/matrix.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/matrix/web/matrix.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    barFX: {
      name: spineKeysConfig.barFX,
      path: 'animations/power_of_gods_new/barFX/web/bar.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/barFX/web/bar.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    x75PopUp: {
      name: spineKeysConfig.x75PopUp,
      path: 'animations/power_of_gods_new/oddPopUps/x75/web/75x.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/oddPopUps/x75/web/75x.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    x225PopUp: {
      name: spineKeysConfig.x225PopUp,
      path: 'animations/power_of_gods_new/oddPopUps/x225/web/225x.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/oddPopUps/x225/web/225x.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    lightning: {
      name: spineKeysConfig.lightning,
      path: 'animations/power_of_gods_new/bonusReelLights/web/lights.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/bonusReelLights/web/lights.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    transition: {
      name: spineKeysConfig.transition,
      path: 'animations/power_of_gods_new/bonusTransition/web/transition.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/bonusTransition/web/transition.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    images: {
      name: 'bettingPart',
      path: 'atlases/web/bettingPart.json',
    },
  };

  const mobileSceneSpineResources = {
    0: {
      name: reelSymbolNames.medusa,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/medusa/medusa.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/medusa/medusa.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    1: {
      name: reelSymbolNames.hermes,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/hermes/hermes.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/hermes/hermes.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    2: {
      name: reelSymbolNames.ares,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/ares/ares.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/ares/ares.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    3: {
      name: reelSymbolNames.aphrodite,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/aphrodite/Aphrodite.json',
      config: {
        metadata: {
          spineAtlasFile:
            'animations/power_of_gods_new/reelSymbols/mobile/aphrodite/Aphrodite.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    4: {
      name: reelSymbolNames.zeus,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/zeus/zeus.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/zeus/zeus.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    6: {
      name: reelSymbolNames.x100,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/x100/100.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/x100/100.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    7: {
      name: reelSymbolNames.x200,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/x200/200.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/x200/200.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    8: {
      name: reelSymbolNames.x300,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/x300/300.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/x300/300.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    9: {
      name: reelSymbolNames.x400,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/x400/400.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/x400/400.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    10: {
      name: reelSymbolNames.x500,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/x500/500.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/x500/500.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    11: {
      name: reelSymbolNames.x550,
      path: 'animations/power_of_gods_new/reelSymbols/mobile/x550/550.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/reelSymbols/mobile/x550/550.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    matrix: {
      name: spineKeysConfig.matrix,
      path: 'animations/power_of_gods_new/matrix/mobile/matrix.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/matrix/mobile/matrix.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    barFX: {
      name: spineKeysConfig.barFX,
      path: 'animations/power_of_gods_new/barFX/mobile/bar.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/barFX/mobile/bar.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    x75PopUp: {
      name: spineKeysConfig.x75PopUp,
      path: 'animations/power_of_gods_new/oddPopUps/x75/mobile/75x.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/oddPopUps/x75/mobile/75x.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    x225PopUp: {
      name: spineKeysConfig.x225PopUp,
      path: 'animations/power_of_gods_new/oddPopUps/x225/mobile/225x.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/oddPopUps/x225/mobile/225x.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    lightning: {
      name: spineKeysConfig.lightning,
      path: 'animations/power_of_gods_new/bonusReelLights/mobile/lights.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/bonusReelLights/mobile/lights.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    transition: {
      name: spineKeysConfig.transition,
      path: 'animations/power_of_gods_new/bonusTransition/mobile/transition.json',
      config: {
        metadata: {
          spineAtlasFile: 'animations/power_of_gods_new/bonusTransition/mobile/transition.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    images: {
      name: 'bettingPart',
      path: 'atlases/mobile/bettingPart.json',
    },
  };

  return [...Object.values(isMobile() ? mobileSceneSpineResources : webSceneSpineResources)];
};

export const RISK_TYPES_FOR_CLASS = {
  2: 'low',
  1: 'medium',
  0: 'high',
};

export const SECTORS_TYPES_FOR_CLASS = {
  0: '10',
  1: '20',
  2: '30',
  3: '40',
  4: '50',
};

export const POWER_OF_GODS_GAME_ID = 208;

export const PowerOfGodsLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const PowerOfGodsBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => {
      return (
        <i
          onClick={(e) => {
            e.stopPropagation();
            popupStore.open({ name: PopupTypes.Fairness, spinInfo });
            checkHashStore.setSpinInfo({
              salt: spinInfo.salt,
              key: spinInfo.key,
              hash: spinInfo.hash,
            });
          }}
          className='icon-fairness-fill cpt-table-column-icon'
        />
      );
    },
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const PowerOfGodsSoundsNames = {
  WinPopUp: 'WinPopUp',
  SpinButton: 'SpinButton',
  ReelStart: 'ReelStart',
  ReelStop: 'ReelStop',
  ReelLoop: 'ReelLoop',
  Music: 'Music',
  MinusButton: 'MinusButton',
  PlusButton: 'PlusButton',
  OtherButton: 'OtherButton',
  LoadRing: 'LoadRing',
  ReverseLoadRing1Step: 'ReverseLoadRing1Step',
  ReverseLoadBigRingAfterBonus: 'ReverseLoadBigRingAfterBonus',
  BonusMusic: 'BonusMusic',
  BonusReelLights: 'BonusReelLights',
  Zeus: 'Zeus',
  Aphrodite: 'Aphrodite',
  Ares: 'Ares',
  Medusa: 'Medusa',
  Hermes: 'Hermes',
  SmallCashOut: 'SmallCashOut',
  MiddleCashOut: 'MiddleCashOut',
  bgMusic: 'bg-music',
};

export const SymbolSoundMap = {
  0: PowerOfGodsSoundsNames.Medusa,
  1: PowerOfGodsSoundsNames.Hermes,
  2: PowerOfGodsSoundsNames.Ares,
  3: PowerOfGodsSoundsNames.Aphrodite,
  4: PowerOfGodsSoundsNames.Zeus,
};

export const PowerOfGodsSounds = [
  {
    src: 'audio/powerOfGods/PoG_ZEUS SYMBOL.mp3',
    name: PowerOfGodsSoundsNames.Zeus,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_ARTEMIDA SYMBOL.mp3',
    name: PowerOfGodsSoundsNames.Aphrodite,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_ARES SYMBOL.mp3',
    name: PowerOfGodsSoundsNames.Ares,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_GORGONA SYMBOL NEW.mp3',
    name: PowerOfGodsSoundsNames.Medusa,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_HERMES SYMBOL.mp3',
    name: PowerOfGodsSoundsNames.Hermes,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_MAIN MUSIC new.mp3',
    name: PowerOfGodsSoundsNames.bgMusic,
    autoplay: false,
    html5: true,
    loop: false,
    buffer: true,
    onplay: function () {
      this._sounds[0]._node.bufferTime = 0.5; // need it for safari
    },
    onend: function () {
      soundService.play(PowerOfGodsSoundsNames.bgMusic);
    },
  },
  {
    src: 'audio/powerOfGods/PoG_BONUS  MUSIC.mp3',
    name: PowerOfGodsSoundsNames.BonusMusic,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_win popup new.mp3',
    name: PowerOfGodsSoundsNames.WinPopUp,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_spin button.mp3',
    name: PowerOfGodsSoundsNames.SpinButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_OTHER BUTTON.mp3',
    name: PowerOfGodsSoundsNames.OtherButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_reel sound(STOP)(VERSION2).mp3',
    name: PowerOfGodsSoundsNames.ReelStop,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_reel sound(START)(VERSION2).mp3',
    name: PowerOfGodsSoundsNames.ReelStart,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_reel sound(LOOP)(VERSION2).mp3',
    name: PowerOfGodsSoundsNames.ReelLoop,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_reel win(gci sound).mp3',
    name: PowerOfGodsSoundsNames.LoadRing,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_reel loose (gci sound) karch.mp3',
    name: PowerOfGodsSoundsNames.ReverseLoadRing1Step,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_reel loose (gci sound) erkar.mp3',
    name: PowerOfGodsSoundsNames.ReverseLoadBigRingAfterBonus,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_BONUS GAME KAYCAKNER.mp3',
    name: PowerOfGodsSoundsNames.BonusReelLights,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_OTHER BUTTON3(Minus).mp3',
    name: PowerOfGodsSoundsNames.MinusButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/PoG_OTHER BUTTON2(Plus).mp3',
    name: PowerOfGodsSoundsNames.PlusButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/7.5 WIN.mp3',
    name: PowerOfGodsSoundsNames.SmallCashOut,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/powerOfGods/22.5 WIN.mp3',
    name: PowerOfGodsSoundsNames.MiddleCashOut,
    autoplay: false,
    html5: true,
  },
];
export const powerOfGodsCanvasTranslations = {
  cashOut: TranslationKeys.CashOut,
  partCashOut: TranslationKeys.PartCashout,
};
export const POWER_OF_GODS_ABOUT_HASH_KEYS = new Array(16)
  .fill(null)
  .map((item, index) => `_P${index + 1}`);
